import React from "react";
import ReactDOM from "react-dom/client";
// Relative, not "@shared/..." - the standalone foyer-cms build aliases
// @shared to foyer-shared/dist (tsc output: no CSS, no font files).
import "../shared/fonts/cms.css";
import App from "./App";
import { installClientErrorReporting } from "@shared/clientErrors";
import { ThemeModeProvider } from "./ThemeMode";

// Uncaught errors and unhandled rejections go to POST /api/client-errors,
// grouped server-side and listed under Settings > Client errors. Installed
// before render so a crash in the first render is caught too.
installClientErrorReporting(
  "cms",
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev"
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </React.StrictMode>
);
